import { isPlatformBrowser } from '@angular/common'
import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { BehaviorSubject } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private readonly STORAGE_KEY = 'menuState'

  private menuStateSubject = new BehaviorSubject<{ [key: string]: boolean }>(this.loadState())

  menuState$ = this.menuStateSubject.asObservable()

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  toggleMenu(menuKey: string): void {
    const currentState = this.menuStateSubject.value
    const newState = {
      ...currentState,
      [menuKey]: !currentState[menuKey],
    }
    this.menuStateSubject.next(newState)
    this.saveState(newState)
  }

  openMenu(menuKey: string): void {
    const currentState = this.menuStateSubject.value
    const newState = {
      ...currentState,
      [menuKey]: true,
    }
    this.menuStateSubject.next(newState)
    this.saveState(newState)
  }

  closeMenu(menuKey: string): void {
    const currentState = this.menuStateSubject.value
    const newState = {
      ...currentState,
      [menuKey]: false,
    }
    this.menuStateSubject.next(newState)
    this.saveState(newState)
  }

  private loadState(): { [key: string]: boolean } {
    if (!isPlatformBrowser(this.platformId)) {
      return { sidebar: true, profileMenu: false, backoffice: true }
    }

    const savedState = localStorage.getItem(this.STORAGE_KEY)
    return savedState
      ? JSON.parse(savedState)
      : { sidebar: true, profileMenu: false, backoffice: true }
  }

  private saveState(state: { [key: string]: boolean }): void {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.STORAGE_KEY, JSON.stringify(state))
    }
  }

  getMenuState(menuKey: string): boolean {
    return this.menuStateSubject.value[menuKey]
  }
}
